<template>
  <div>
    <div>
      <div class="d-flex flex-column gap-2">
        <v-card
          outlined
          flat
        >
          <v-card-title>
            {{ $t('live.examOnboarding.grading.groups.time.title') }}
          </v-card-title>

          <v-list-item
            v-for="(instruction, index) in instructions.filter(i => i.group === 'time')"
            :key="index"
            dense
            class="very-dense"
          >
            <quizzes-instruction-item
              :instruction="instruction"
              dense
            />
          </v-list-item>

          <v-divider class="my-2" />
          <div class="mx-4 mb-2 grey--text text-subtitle-2">
            <real-time-clock>
              <template slot-scope="time">
                {{ $t('live.currentTime') }} {{ time.clock }}
              </template>
            </real-time-clock>
          </div>
        </v-card>

        <v-card
          outlined
          flat
          v-if="instructionsQuizRules.length > 0 || examRulesStudentInfo.length > 0"
        >
          <v-card-title>
            {{ $t('live.examOnboarding.grading.groups.quizRules.title') }}
          </v-card-title>

          <v-list-item
            v-for="(instruction, index) in instructionsQuizRules"
            :key="index"
            dense
            class="very-dense"
          >
            <quizzes-instruction-item
              :instruction="instruction"
              dense
            />
          </v-list-item>

          <quiz-see-more
            :short-text="$t('live.examOnboarding.instructions.title')"
            :learn-more="$t('live.examOnboarding.instructions.learnMore')"
            :see-less="$t('live.examOnboarding.instructions.seeLess')"
            :text="examRulesStudentInfo"
          />
        </v-card>

        <v-card
          outlined
          flat
        >
          <v-card-title>
            {{ $t('live.examOnboarding.grading.groups.grading.title') }}
          </v-card-title>

          <quiz-see-more
            :short-text="$t('live.examOnboarding.grade.title')"
            :learn-more="$t('live.examOnboarding.grade.learnMore')"
            :see-less="$t('live.examOnboarding.grade.seeLess')"
            :text="gradingStudentInfo"
          />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { useQuizSummary } from "@/composables/useQuizSummary"
import { toRefs } from "vue"
import QuizSeeMore from "@/components/quiz/onboarding/quiz_see_more.vue"
import QuizzesInstructionItem from "@/components/quiz/evalmee/quizzes_instruction_item.vue"
import RealTimeClock from "@/components/quiz/evalmee/real_time_clock.vue"

export default {
  name: "QuizStudentInfoSummary",
  components: {
    QuizSeeMore,
    QuizzesInstructionItem,
    RealTimeClock,
  },
  props: {
    quiz: { type: Object, required: true },
    quizzesAttemptSummary: { type: Object, required: false, default: null },
    session: { type: Object, required: false, default: null },
    showLanguageSwitch: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { quiz } = toRefs(props)
    const { gradingStudentInfo, examRulesStudentInfo, inExamInstructions } = useQuizSummary({ quiz: quiz.value })
    return {
      gradingStudentInfo,
      examRulesStudentInfo,
      inExamInstructions,
    }
  },
  data() {
    return {
      showGrading: false,
      showInstructions: false,
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    instructions() {
      return useQuizSummary({
        quiz: this.quiz,
        quizzesAttemptSummary: this.quizzesAttemptSummary,
        session: this.session,
      }).instructions.value
    },
    instructionsQuizRules() {
      return this.instructions.filter(i => i.group === "quizRules")
    },
  },
  methods: {
    ...mapActions(["updateCurrentUser"]),
    saveStudent() {
      this.updateCurrentUser(this.currentUser)
    },
  },
}
</script>

<style scoped>
  a {
    cursor: pointer;
  }
</style>

<style>
  .quiz-tips li {
    list-style-type: disc !important;
    margin-left: 1em;
  }

  .quiz-tips {
    max-width: 650px;
    margin: auto;
    padding: 2em;
  }

  .grading, .instructions {
    white-space: normal !important;
    overflow-wrap: break-word;
    padding-right: 15px;
  }
</style>
